<template>
  <a :href="`tel:${tel}`" v-if="tel" class="link-with-icon">
    <v-icon color="primary" small>mdi-phone</v-icon>
    <span>{{ text }}</span>
  </a>
</template>

<script>
export default {
  name: "linkTel",
  props: {
    tel: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}
span {
  margin-left: 8px;
}
</style>
